<template>
  <v-layout class="mt-3 mb-5 calendar-page" row wrap align-center justify-center>
    <v-flex xl12 class="text-xl-center calendar-custom-header">
      <div class="calendar-custom-header-inner">
        <p><b>Rezervace akce:</b> V kalendáři najděte požadovanou akci a klikněte na ni. Akce jsou označené žlutou
          barvou, vždy je uvedena informace o volné kapacitě.</p>
        <p><b>Půjčovna paddleboardů:</b> V kalendáři najděte vámi požadovaný den a čas a klikněte do prázdného místa v
          kalendáři.</p>
      </div>
    </v-flex>
    <v-flex xl12 class="text-xl-right text-xs-center">
      <v-btn depressed color="primary mb-3" @click="goToHp">Zobrazit obrázkový výpis</v-btn>
    </v-flex>
    <!--v-model="order.datumKonani"-->
    <v-dialog v-if="datePickerShown"
      ref="dialogModal"
      v-model="datePickerModal"
      :return-value.sync="datePickerDate"
      persistent
      lazy
      full-width
      width="290px"
      class="calendar-datepicker"
      color="#ffff"
    >
      <v-text-field
        slot="activator"
        v-model="datePickerDate"
        label="Vyberte datum"
        prepend-icon="event"
        readonly
      ></v-text-field>
      <v-date-picker-override
        v-model="datePickerDate"
        scrollable
        :header-date-format="formatSubHeaderDate"
        :title-date-format="formatHeaderDate"
        :month-format="formatMonths"
        locale="cs_CZ"
        first-day-of-week="1"
        :min=this.minDate
      >
        <!--color="#ffff"-->
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="datePickerModal = false">Zrušit</v-btn>
        <v-btn flat color="primary"
               @click="$refs.dialogModal.save(datePickerDate);calendarSetDate()">
          Potvrdit
        </v-btn>
      </v-date-picker-override>
    </v-dialog>
    <v-flex xl12 class="mx-2">
      <full-calendar
        :events="events"
        ref="calendar"
        :editable="false"
        :selectable="false"
        :selectHelper="false"
        :config="config"
        @event-selected="dateSelect"
        :event-sources="eventSources"
      />
    </v-flex>
  </v-layout>
</template>

<script>
  import {FullCalendar} from 'vue-full-calendar';
  import 'fullcalendar/dist/fullcalendar.css';
  import moment from 'moment-timezone';
  import {init, getPujcovnaEvents} from '@/api/api';
  import VDatePickerOverride from '../overides/VDatePickerOverride';
  import {mapGetters} from 'vuex'

  export default {
    components: {
      FullCalendar,
      VDatePickerOverride,
    },
    data() {
      return {
        datePickerDate: null,
        datePickerModal: false,
        showDatePicker: true,
        datePickerShown: true,
        minDate: moment().format("YYYY-MM-DD"),
        events: [],
        eventSources: [
          {
            events: this.refreshPujcovnaEvents,
          },
          {
            events: this.getAkceEvents,
          },
        ],
        config: {
          locale: 'cs',
          allDaySlot: false,
          businessHours: {
            dow: [0, 1, 2, 3, 4, 5, 6],
            start: '08:00',
            end: '22:00',
          },
          agendaEventMinHeight: 65,
          minTime: '08:00',
          maxTime: '22:00',
          slotLabelInterval: "01:00",
          scrollTime: '08:00:00',
          eventBackgroundColor: '#faba54',
          eventBorderColor: '#faba54',
          // defaultView: window.innerWidth < 600 ? 'agendaDay' : 'month',
          defaultView: 'agendaDay',
          refetchResourcesOnNavigate: true,
          // resources: this.refreshPujcovnaEvents,
          validRange: {
            start: moment().format('YYYY-MM-DD'),
          },
          buttonText: {
            today: 'Aktuální datum',
            month: 'Měsíc',
            week: 'Týden',
            day: 'Den',
            list: 'list'
          },
          columnHeaderFormat: [
            'dddd D. M.',
          ],
          select: function (start, end, jsEvent, view, [resource]) {
            console.log(start);
          },
          view: {
            month: {
              columnHeaderText: [
                'MMMM YYYY', // top level of text
                'MMMM YYYY'        // lower level of text
              ],
            }
          },
          viewRender: this.renderCalendar,
        },
      }
    },
    methods: {
      next() {
        this.$refs.calendar.fireMethod('next')
      },
      calendarSetDate() {
        this.$refs.calendar.fireMethod("gotoDate", moment(this.datePickerDate, "YYYY-MM-DD"));
      },
      changeView(view) {
        this.$refs.calendar.fireMethod('changeView', view)
      },
      refreshPujcovnaEvents(start, end, timezone, callback) {

        if (!start || !end) {
          return callback([]);
        }

        let lEvents = [];

        let tStart = moment.tz(start.format('YYYY-MM-DD HH:mm'), 'Europe/Prague').utc();
        let tEnd = moment.tz(end.format('YYYY-MM-DD HH:mm'), 'Europe/Prague').utc();

        this.getPujcovnaEvents(tStart.format('YYYY-MM-DD_HH:mm'), tEnd.format('YYYY-MM-DD_HH:mm')).then((response) => {
          response.data.events.forEach((item) => {
            lEvents.push({
              title: 'Půjčovna ( ' + item.sklady + ' volných míst )',
              start: moment.utc(item.from).tz('Europe/Prague'),
              end: moment.utc(item.to).tz('Europe/Prague'),
              allDay: false,
              color: '#ddd',
            });
          });

          callback(lEvents);
        });
      },
      dateSelect(event, jsEvent, view) {
        let id = event.id;

        if (typeof id === "undefined") {
          id = this.getMainServiceID.nid;
        }

        this.$store.dispatch('setService', id).then(() => {
          this.$router.push({
            name: 'Step2',
            params: {actionID: id, prevRoute: 'Calendar', dateTimeFrom: moment(event.start).format('YYYY-MM-DD HH:mm'),}
          });
        })
      },
      dayClick(date, jsEvent, view) {
        this.$store.dispatch('setService', this.getMainServiceID.nid).then(() => {
          this.$router.push({
            name: 'Step2',
            params: {
              actionID: this.getMainServiceID.nid,
              dateTimeFrom: moment(date).format('YYYY-MM-DD HH:mm'),
              prevRoute: 'Calendar'
            },
          });
        })
      },
      renderCalendar(view, element) {
        if (view.name == 'agendaDay') {
          this.datePickerShown = true;
        }else{
          this.datePickerShown = false;
        }
        console.log(this.datePickerShown);
        if (view.name == 'month') {

          moment.locale("cs");

          document.querySelectorAll(".fc-day-top").forEach((item) => {
            item.firstChild.textContent = moment(item.getAttribute("data-date")).format('dddd D. M.');
          });
        }
      },
      formatSubHeaderDate(originalDate) {
        return moment(originalDate).format('MM. YYYY');
      },
      formatHeaderDate(originalDate) {
        return moment(originalDate).format('DD. MM. YYYY');
      },
      formatMonths(originalMonth) {
        // console.log(originalMonth);
        return moment(originalMonth).locale('cs').format('MMM');
      },
      goToHp() {
        this.$router.push({name: 'Step1'});
      },
      getPujcovnaEvents,
      getAkceEvents(start, end, timezone, callback) {
        init(-1).then(response => {

          let lEvents = [];

          this.$store.commit('setActionsList', response.data.data.actions);
          this.$store.commit('setPobockyOptions', response.data.data.pobocky_options);

          this.$store.state.services.forEach((item) => {

            if (item.nid != 4 && item.nid != 281 && item.nid != 1982) {
              lEvents.push({
                id: item.nid,
                title: item.title + ' ( ' + item.volna_mista + ' volných míst )',
                start: moment.utc(item.field_akce_datum_od_do_value).tz('Europe/Prague'),
                end: moment.utc(item.field_akce_datum_od_do_value2).tz('Europe/Prague'),
                allDay: false,
              });
            }
          });

          callback(lEvents);

        })
      },
    },
    computed: {
      ...mapGetters([
        'getMainServiceID',
      ]),
    },
    mounted() {

    },
    watch: {
      // datePickerShown() {
      //   this.showDatePicker = false;
      //   this.$nextTick(function () {
      //     this.showDatePicker = true;
      //   });
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Calendar.vue